/*
 * vocal-only-export.js — «глушить только голос»: разделитель и подложка.
 *
 * ЗАЧЕМ. Обычная заглушка глушит ВСЁ, что звучит в момент слова: вместе с
 * матом пропадают игра, музыка, подложка подкаста. Для песни это дыра в миксе,
 * для игрового ролика — пропавшие выстрелы и музыка ровно там, где стример
 * выругался (Ангелина, #640, 24.09.2026: игровые ролики по 37 минут и по две
 * сотни заглушек). Радиоверсии делают иначе: глушат ГОЛОС, а всё, что под ним,
 * продолжает звучать.
 *
 * КАК (с 24.09.2026, волна 3):
 *   · это не отдельная кнопка, а ФЛАЖОК в «Чем заглушать» на обеих страницах
 *     (раньше — кнопка «Скачать с музыкой» только у аудио, мимо предпросмотра);
 *   · разделяются только ОКНА вокруг заглушек (заглушка ± 1 с, не короче чанка
 *     разделителя; соседние сливаются). Звук окна достаёт FFmpeg прямо с диска
 *     (`-ss` с секундой разгона декодера, WORKERFS) — запись целиком в память
 *     не декодируется, и 37-минутное видео стоит столько же памяти, сколько
 *     его заглушки;
 *   · «не голос» проходит гейт по полосе голоса (voice-post-filter.js): после
 *     голого Kim распознавание ещё читало мат в 9 фразах из 98 (игра на 6 дБ
 *     тише голоса) — искажённый след голоса, которого линейная метрика не
 *     видит; с гейтом — в 0 из 98, игре это стоит 0.5 дБ;
 *   · результат — «не голос» — кэшируется по окнам: правка заглушки в пределах
 *     запаса не требует разделять заново, новая — разделяет одно окно;
 *   · в предпросмотре под заглушкой звучит то же, что ляжет в файл (ядро
 *     проигрывает «не голос» с дополняющей громкостью);
 *   · экспорт — граф ядра + ПОДЛОЖКА (voice-underlay.js): нули-ссылки во всю
 *     длину и заплатки под заглушками. Видео идёт своим контейнером и `-c:v
 *     copy`, как обычный экспорт, — ядро одно, кап и телеметрия его.
 *
 * До 24.09.2026 (утро) лейн не работал НИ РАЗУ (разделитель не грузился —
 * 95/95 MDX_MISSING), а после починки держал запись трижды в памяти
 * (декод + копия + WAV) и был только у аудио.
 *
 * ⚠️ Лейн ДОПОЛНИТЕЛЬНЫЙ: без флажка ядро работает как работало, а любой сбой
 * разделения говорит об этом словами и оставляет обычную заглушку.
 */
(function (w) {
    'use strict';

    var d = w.document || null;
    var $ = function (id) { return d ? d.getElementById(id) : null; };

    // Контекст разделителю по обе стороны заглушки, и окно не короче ОДНОГО
    // чанка разделителя: MDX короткое окно всё равно добивает нулями до чанка
    // (GEN = 253 440 сэмплов при 44.1 кГц ≈ 5.75 с), цена та же, а вместо нулей
    // модель видит настоящий звук. Замер 24.09 на MUSDB18 (Kim, 6 заглушек):
    // голос под музыкой −28.0 дБ против −26.7 у окна «заглушка ± 1 с».
    var CTX_S = 1.0;
    var MIN_WIN_S = { kim: 5.75, cascade: 5.75, musion: 7.8 };
    // Сколько «не голоса» хранить вокруг заглушек окна: край, сдвинутый в этих
    // пределах, не требует нового разделения.
    var MARGIN_S = 0.75;
    var DEBOUNCE_MS = 700;

    function lane() { return $('pc-voice-only-row'); }
    function t(key, fallback) {
        var el = lane();
        var v = el && el.getAttribute('data-' + key);
        return v || fallback;
    }
    function say(msg, kind) {
        var el = $('pc-voice-only-state');
        if (!el) return;
        el.textContent = msg || '';
        el.setAttribute('data-kind', kind || '');
    }
    function slug() {
        try { return (w.__pcTool && w.__pcTool._state && w.__pcTool._state().slug) || w.__TOOL_SLUG || ''; } catch (e) { return ''; }
    }
    function report(action, extra) {
        try {
            var p = { tool: slug(), feature: 'voice_only', action: action };
            for (var k in (extra || {})) p[k] = extra[k];
            if (w.__ae) w.__ae('feature_use', p);
        } catch (e) { /* телеметрия не смеет ломать экспорт */ }
    }
    function minutes(s) { return Math.max(1, Math.round(s / 60)); }

    /* ── Окна разделения ─────────────────────────────────────────────────
       Чистая функция (tests/js/profanity-vocal-lane.test.mjs): заглушки →
       отрезки [a,b] с контекстом, не короче minS (раздвигаются поровну, у края
       записи — в одну сторону), слитые, если пересекаются. */
    function windowsFor(regions, duration, ctxS, minS) {
        var c = typeof ctxS === 'number' ? ctxS : CTX_S;
        var m = Math.min(typeof minS === 'number' ? minS : 0, duration);
        var rs = (regions || []).filter(function (r) { return r && r.end > r.start; })
            .slice().sort(function (x, y) { return x.start - y.start; });
        var out = [];
        for (var i = 0; i < rs.length; i++) {
            var a = Math.max(0, rs[i].start - c), b = Math.min(duration, rs[i].end + c);
            if (b - a < m) {
                var need = m - (b - a), left = Math.min(a, need / 2), right = Math.min(duration - b, need - left);
                left = Math.min(a, need - right);
                a -= left; b += right;
            }
            var last = out[out.length - 1];
            if (last && a <= last.b) { last.b = Math.max(last.b, b); last.regions.push(rs[i]); }
            else out.push({ a: a, b: b, regions: [rs[i]] });
        }
        return out;
    }

    /* Хранимый кусок окна: [lo, hi) в сэмплах записи, «не голос» перемежённым
       int16. Покрывает отрезок, если лежит в нём целиком. */
    function covers(entry, i0, i1) { return entry.lo <= i0 && entry.hi >= i1; }

    /* ── Разделитель ─────────────────────────────────────────────────────
       Какой — решает конфиг (config/separators.php → data-атрибуты строки).
       Скрипт грузится по требованию: десятки МБ модели нужны только тем, кто
       поставил флажок. */
    var loads = {};
    function engineOf(global) {
        var e = global ? w[global] : null;
        return (e && typeof e.split === 'function') ? e : null;
    }
    function loadEngine(url, global) {
        if (engineOf(global)) return Promise.resolve(engineOf(global));
        if (!url || !d) return Promise.resolve(null);
        if (!loads[url]) {
            loads[url] = new Promise(function (resolve) {
                var s = d.createElement('script');
                s.src = url;
                // свойства, а не HTML-атрибуты: InlineHandlerBudgetTest
                s.onload = function () { resolve(engineOf(global)); };
                s.onerror = function () { resolve(null); };
                d.head.appendChild(s);
            });
        }
        return loads[url];
    }
    // Какую долю onProgress разделителя занимает инференс (config/separators.php
    // `infer_span`): до неё — скачивание модели, после — работа над окном.
    function span(s) {
        var p = String(s || '').split(',').map(parseFloat);
        return (p.length === 2 && p[1] > p[0]) ? p : [0, 1];
    }
    function cfg() {
        var el = lane() || { getAttribute: function () { return null; } };
        return {
            key: el.getAttribute('data-sep-key') || 'kim',
            global: el.getAttribute('data-sep-global') || 'MdxStemSeparator',
            url: el.getAttribute('data-sep-url') || '',
            mb: parseInt(el.getAttribute('data-sep-mb') || '0', 10) || 0,
            span: span(el.getAttribute('data-sep-span')),
            fbGlobal: el.getAttribute('data-fb-global') || 'StemSeparator',
            fbUrl: el.getAttribute('data-fb-url') || '',
            fbSpan: span(el.getAttribute('data-fb-span'))
        };
    }

    /* CascadedNet после Kim на одной странице: среда ORT одна, её режим решает
       первая сессия — поднять поколение и отпустить `window.ort` (тот же
       договор поколений, что у mdx-stem-separator.js / stem-separator.js). */
    var handedOffGen = -1;
    function freshRuntimeFor(fallback) {
        try {
            var k = w.MdxStemSeparator;
            if (!w.ort || (w.__ortGen | 0) === handedOffGen) return;
            if (!(k && typeof k.isWarm === 'function' && k.isWarm())) return;
            w.__ortGen = (w.__ortGen | 0) + 1;
            handedOffGen = w.__ortGen;
            try { delete w.ort; } catch (e) { w.ort = undefined; }
            report('runtime_handoff', { to: fallback });
        } catch (e) { /* лучше попытка на старой среде, чем отказ */ }
    }

    /* «Призраки» голоса в «не голосе» — искажённый след, который проекция на
       голос не видит, а распознавание читает: Kim оставлял разборчивый мат в 9
       фразах из 98 (игра на 6 дБ тише голоса), с гейтом — в 0, игре это стоит
       0.5 дБ (voice-post-filter.js, замер там же). Гейт работает на стемах в
       частоте разделителя; нет голосового стема или модуля — «не голос» как есть. */
    var POST = { bandLow: 300, bandHigh: 4000, alpha: 1.0 };
    function postFilter(inst, vocal) {
        var F = w.VoicePostFilter;
        if (!F || !vocal || vocal.length !== inst.length || vocal.sampleRate !== inst.sampleRate) return inst;
        var ic = [], vc = [];
        for (var c = 0; c < inst.numberOfChannels; c++) {
            ic.push(inst.getChannelData(c));
            vc.push(vocal.getChannelData(Math.min(c, vocal.numberOfChannels - 1)));
        }
        var out = F.apply(ic, vc, inst.sampleRate, POST);
        var buf = new AudioBuffer({ length: inst.length, numberOfChannels: inst.numberOfChannels, sampleRate: inst.sampleRate });
        for (var c2 = 0; c2 < inst.numberOfChannels; c2++) buf.copyToChannel(out.inst[c2], c2);
        return buf;
    }

    /* Стем разделителя → частота и раскладка записи. */
    async function toSourceFormat(stem, sr, ch, length) {
        if (stem.sampleRate === sr && stem.numberOfChannels === ch && stem.length >= length) return stem;
        var off = new (w.OfflineAudioContext || w.webkitOfflineAudioContext)(ch, length, sr);
        var src = off.createBufferSource();
        src.buffer = stem;
        src.connect(off.destination);
        src.start(0);
        return off.startRendering();
    }

    /* Звук окна [a, b] — FFmpeg прямо с диска, с секундой разгона декодера
       (голый `-ss` портит первые десятки мс: у AAC нет перекрытия предыдущего
       кадра, у MP3 — резервуара битов). Шкала времени — та же, что у
       распознавания и у графа экспорта: `aresample=async=1:first_pts=0`. */
    async function decodeWindow(file, a, b, sr, ch) {
        var P = w.FFmpegProcessor;
        if (!P || !(await P.init())) throw new Error('FFMPEG_INIT');
        var pre = Math.min(1, a), x = a - pre;
        var af = 'aresample=async=1:first_pts=0,atrim=start=' + pre.toFixed(6) + ',asetpts=PTS-STARTPTS';
        var res = await P.processStreaming(file,
            ['-vn', '-map', '0:a:0', '-af', af, '-ac', String(ch), '-ar', String(sr), '-c:a', 'pcm_f32le', '-f', 'f32le'],
            'pc-voice-window.raw', null, ['-ss', x.toFixed(6), '-t', (b - x).toFixed(6)]);
        var f32 = new Float32Array(await res.blob.arrayBuffer());
        try { if (res.url) URL.revokeObjectURL(res.url); } catch (e) { /* noop */ }
        var chans = w.ProfanityVoiceUnderlay.deinterleave(f32, ch);
        var n = chans[0].length;
        if (!n) throw new Error('EMPTY_WINDOW');
        var buf = new AudioBuffer({ length: n, numberOfChannels: ch, sampleRate: sr });
        for (var c = 0; c < ch; c++) buf.copyToChannel(chans[c], c);
        return buf;
    }

    /* ── Состояние ─────────────────────────────────────────────────────── */
    var S = {
        active: false, file: null, sr: 0, ch: 0, duration: 0, regions: [],
        cache: [], engine: null, used: '', failed: '', pumping: null, ctl: null,
        doneS: 0, planS: 0, rate: 0, t0: 0, gen: 0, timer: 0, previews: {}
    };

    function resetFor(file) {
        if (S.ctl) try { S.ctl.abort(); } catch (e) { /* noop */ }
        S.file = file; S.cache = []; S.failed = ''; S.pumping = null; S.ctl = null;
        S.doneS = 0; S.planS = 0; S.t0 = 0; S.gen++; S.previews = {}; S.go = false;
        goButton(false);
    }

    function goButton(show) {
        var b = $('pc-voice-only-go');
        if (b) b.hidden = !show;
    }

    /* Запускать ли разделение сейчас. Быстрое устройство — сразу, в фоне:
       человек правит заглушки, а предпросмотр уже звучит как файл. Медленное —
       не молча: время называется, и человек решает, начать сейчас или при
       скачивании (экспорт запускает разделение в любом случае). Нажатое «сейчас»
       действует до смены файла — новые заглушки разделяются сами. */
    async function decide() {
        if (!S.active || S.failed) return;
        var wins = missingWindows();
        if (!wins.length) { if (!S.pumping) { goButton(false); say(t('msg-ready', 'Ready.'), 'ok'); } return; }
        var gen = S.gen;
        try { await ensureEngine(); } catch (e) {
            if (gen !== S.gen) return;
            S.failed = (e && e.message) || String(e || '');
            report('failed', { error: S.failed.slice(0, 80), engine: S.used, stage: 'engine' });
            say(S.failed === 'NO_SIMD'
                ? t('msg-impossible', 'This device cannot run the voice separator — the censor will mute everything, as usual.')
                : t('msg-failed', 'Could not separate the voice — the censor will mute everything, as usual.'), 'error');
            return;
        }
        if (gen !== S.gen || !S.active) return;
        if (S.fast || S.go || S.pumping) { goButton(false); pump(); return; }
        var restS = wins.reduce(function (s, x) { return s + (x.b - x.a); }, 0);
        var etaS = restS * S.rate;
        goButton(true);
        say(t('msg-slow', 'On this device separating the voice takes ≈ :min min, and the tab will stutter meanwhile. Start now or when downloading.')
            .replace(':min', String(minutes(etaS))), 'wait');
        if (!S.offered) { S.offered = true; report('slow_offer', { eta_s: Math.round(etaS), win_s: Math.round(restS), verdict: S.verdict }); }
    }

    /* Отрезки, которых кэш ещё не покрывает, и окна для них. */
    function missingWindows() {
        var U = w.ProfanityVoiceUnderlay;
        var total = Math.ceil((S.duration + 2) * S.sr);
        var need = [];
        (S.regions || []).forEach(function (r) {
            var sp = U.spansFor([r], S.sr, total)[0];
            if (!sp) return;
            for (var k = 0; k < S.cache.length; k++) if (covers(S.cache[k], sp.i0, sp.i1)) return;
            need.push(r);
        });
        return windowsFor(need, S.duration, CTX_S, MIN_WIN_S[S.used || cfg().key] || 5.75);
    }

    function progressLine() {
        var done = S.doneS + (S.curF || 0) * (S.curS || 0);
        var pct = S.planS > 0 ? Math.round(Math.min(1, done / S.planS) * 100) : 0;
        var line = t('msg-progress', 'Separating the voice… :pct%').replace(':pct', String(pct));
        var restS = S.planS - done;
        if (S.rate > 0 && restS * S.rate > 45) {
            line += ' · ' + t('msg-eta', '≈ :min min').replace(':min', String(minutes(restS * S.rate)));
        }
        return line;
    }

    async function ensureEngine() {
        if (S.engine) return S.engine;
        var C = cfg();
        say(t('msg-loading', 'Loading the voice separator (once)…'), 'busy');
        var engine = C.key === 'cascade' ? null : await loadEngine(C.url, C.global), verdict = null;
        if (engine && typeof engine.defaultEngineVerdict === 'function') {
            try { verdict = await engine.defaultEngineVerdict(); } catch (e) { verdict = null; }
            if (verdict && verdict.impossible) throw new Error('NO_SIMD');
        }
        S.used = C.key;
        // Быстро ли здесь разделение. Kim без WebGPU считает WASM в ГЛАВНОМ
        // потоке: чанк на слабом десктопе — десятки секунд замершей вкладки
        // (замер 24.09 в headless: 29 с звука за 41–133 с). Молча запускать это
        // в фоне, пока человек правит заглушки, нельзя — см. decide().
        S.fast = !!(verdict && verdict.ultra);
        S.verdict = verdict ? String(verdict.reason || '') : '';
        if (!engine) {
            freshRuntimeFor('cascade');
            engine = await loadEngine(C.fbUrl, C.fbGlobal);
            S.used = 'cascade';
            S.fast = true;   // CascadedNet без WebGPU уходит в прокси-воркер ORT — вкладка не замирает
            if (!engine) throw new Error('ENGINE_MISSING');
        }
        // честное время ДО работы: сколько секунд разделения на секунду звука
        S.rate = (verdict && verdict.rate) || (engine.storedRate && engine.storedRate()) ||
            (verdict ? (verdict.device ? (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 6 : 0.5) : 9.6) : 2);
        S.engine = engine;
        report('engine', { engine: S.used, rate: Math.round(S.rate * 10) / 10, verdict: verdict ? String(verdict.reason || '') : '' });
        return engine;
    }

    async function separateWindow(win, gen, signal) {
        // окно начинается на сэмпле: сэмпл k окна — ровно сэмпл i0win + k записи
        win = { a: Math.floor(win.a * S.sr) / S.sr, b: win.b, regions: win.regions };
        var buf = await decodeWindow(S.file, win.a, win.b, S.sr, S.ch);
        if (gen !== S.gen) return;
        // проценты идут и ВНУТРИ окна: на слабом устройстве окно — минута,
        // и «0 %» всё это время читается как зависание
        S.curS = win.b - win.a; S.curF = 0;
        var onProgress = function (f) {
            if (gen !== S.gen) return;
            var sp = S.used === 'cascade' ? cfg().fbSpan : cfg().span;
            if (f < sp[0]) {
                say(t('msg-loading', 'Loading the voice separator (once)…') + ' ' + Math.round(f / sp[0] * 100) + '%', 'busy');
                return;
            }
            S.curF = Math.min(1, (f - sp[0]) / (sp[1] - sp[0]));
            say(progressLine(), 'busy');
        };
        var stems;
        try {
            stems = await S.engine.split(buf, { slug: slug(), signal: signal, onProgress: onProgress });
        } catch (e) {
            var m = String((e && e.code) || (e && e.message) || e);
            /* Only the user's cancel (this window's signal) skips the fallback —
               «cancel|abort» in the text also matched a separator dying with
               «Aborted()», which then failed the voice lane instead of falling back. */
            var cancelled = w.__isUserCancel ? w.__isUserCancel(e, signal) : !!(signal && signal.aborted);
            if (cancelled || S.used === 'cascade') throw e;
            // точный разделитель не поднялся (обрыв модели, клин WebGPU) — грубый
            // рядом, и об этом говорится: слово может остаться слышно
            report('engine_fallback', { reason: m.slice(0, 100) });
            if (w.__toast) w.__toast(t('msg-fallback', 'The precise separator did not start — using a rougher one; the word may stay faintly audible.'), 'warning');
            freshRuntimeFor('cascade');
            var C = cfg();
            S.engine = await loadEngine(C.fbUrl, C.fbGlobal);
            S.used = 'cascade';
            if (!S.engine) throw e;
            stems = await S.engine.split(buf, { slug: slug(), signal: signal, onProgress: onProgress });
        }
        S.curF = 0; S.curS = 0;
        if (gen !== S.gen) return;
        var inst = stems && (stems.instrumental || stems.accompaniment);
        if (!inst) throw new Error('NO_INSTRUMENTAL');
        inst = postFilter(inst, stems.vocal || stems.vocals || null);
        inst = await toSourceFormat(inst, S.sr, S.ch, buf.length);
        var i0win = Math.round(win.a * S.sr);
        var lo = Math.max(i0win, Math.floor((win.regions[0].start - MARGIN_S) * S.sr));
        var last = win.regions[win.regions.length - 1];
        var hi = Math.min(i0win + buf.length, Math.ceil((last.end + MARGIN_S) * S.sr));
        var n = Math.max(0, hi - lo), ch = S.ch, data = new Int16Array(n * ch);
        for (var c = 0; c < ch; c++) {
            var src = inst.getChannelData(Math.min(c, inst.numberOfChannels - 1));
            for (var j = 0; j < n; j++) {
                var x = src[lo - i0win + j] || 0;
                x = x > 1 ? 1 : x < -1 ? -1 : x;
                data[j * ch + c] = Math.round(x * 32767);
            }
        }
        S.cache.push({ lo: lo, hi: hi, data: data });
    }

    /* Разделить всё, чего не хватает. Один насос на запись: повторный вызов
       ждёт текущий и доделывает то, что добавилось за это время. */
    function pump() {
        if (S.pumping) return S.pumping;
        var gen = S.gen;
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        S.ctl = ctl;
        S.pumping = (async function () {
            // смерть вкладки посреди разделения (телефон, две модели в памяти)
            // должна быть видна детектору падений ядра, как смерть в распознавании
            try { if (w.__pcTool && w.__pcTool.voiceBusy) w.__pcTool.voiceBusy(true); } catch (e) { /* noop */ }
            try {
                await ensureEngine();
                for (;;) {
                    if (gen !== S.gen) return;
                    var wins = missingWindows();
                    if (!wins.length) break;
                    var restS = wins.reduce(function (s, x) { return s + (x.b - x.a); }, 0);
                    S.planS = S.doneS + restS;
                    if (!S.t0) {
                        S.t0 = Date.now();
                        report('prepare_start', { windows: wins.length, win_s: Math.round(restS), eta_s: Math.round(restS * S.rate), engine: S.used });
                    }
                    say(progressLine(), 'busy');
                    var win = wins[0], ts = Date.now();
                    await separateWindow(win, gen, ctl ? ctl.signal : undefined);
                    var dt = (Date.now() - ts) / 1000;
                    S.doneS += win.b - win.a;
                    // измеренный темп важнее оценки с первого окна
                    if (win.b - win.a > 1) S.rate = S.rate > 0 ? (S.rate + dt / (win.b - win.a)) / 2 : dt / (win.b - win.a);
                    say(progressLine(), 'busy');
                }
                if (gen !== S.gen) return;
                if (S.t0) report('prepare_done', { ms: Date.now() - S.t0, win_s: Math.round(S.doneS), engine: S.used, windows: S.cache.length });
                S.t0 = 0;
                say(t('msg-ready', 'Ready: under the censors you hear what was behind the voice — in the preview and in the file.'), 'ok');
            } catch (e) {
                if (gen !== S.gen) return;
                var msg = (e && e.message) || String(e || '');
                /* A cancel is THIS pump's signal: FFmpeg's terminate on the user's
                   Cancel has no «abort» in it, so it set S.failed and the lane
                   refused for the rest of the file; a dying engine's «Aborted()»
                   went the other way — reported as a cancel. */
                if (w.__isUserCancel ? w.__isUserCancel(e, ctl && ctl.signal) : !!(ctl && ctl.signal.aborted)) { report('cancelled', { engine: S.used }); say(''); throw e; }
                S.failed = msg;
                report('failed', { error: msg.slice(0, 80), engine: S.used });
                say(msg === 'NO_SIMD'
                    ? t('msg-impossible', 'This device cannot run the voice separator — the censor will mute everything, as usual.')
                    : t('msg-failed', 'Could not separate the voice — the censor will mute everything, as usual.'), 'error');
                throw e;
            } finally {
                if (gen === S.gen) { S.pumping = null; S.ctl = null; }
                try { if (w.__pcTool && w.__pcTool.voiceBusy) w.__pcTool.voiceBusy(false); } catch (e) { /* noop */ }
            }
        })();
        S.pumping.catch(function () { /* сказано словами выше */ });
        return S.pumping;
    }

    /* ── Контракт с ядром ─────────────────────────────────────────────────
       update — ядро сообщает, что изменилось (флажок, файл, заглушки);
       previewAt — «не голос» под заглушкой в момент t (для предпросмотра);
       underlay — подложка для экспорта (ждёт, пока всё нужное разделено). */
    var provider = {
        update: function (ctx) {
            ctx = ctx || {};
            if (ctx.file !== S.file) resetFor(ctx.file || null);
            S.sr = ctx.sampleRate || S.sr; S.ch = ctx.channels || S.ch;
            S.duration = ctx.duration || S.duration;
            S.regions = (ctx.regions || []).map(function (r) { return { start: r.start, end: r.end }; });
            var was = S.active;
            S.active = !!(ctx.active && S.file && S.sr && S.ch);
            if (!S.active) {
                if (S.ctl) try { S.ctl.abort(); } catch (e) { /* noop */ }
                if (was) report('off', {});
                goButton(false);
                say('');
                return;
            }
            if (S.failed) return;          // один отказ за файл: не молотить разделитель по кругу
            clearTimeout(S.timer);
            // перетаскивание края перестраивает заглушки на каждом движении —
            // решать, когда рука остановилась
            S.timer = setTimeout(decide, was ? DEBOUNCE_MS : 0);
        },
        /* «Отделить сейчас» на медленном устройстве */
        go: function () {
            if (!S.active || S.failed) return;
            S.go = true;
            goButton(false);
            report('go', { verdict: S.verdict });
            pump();
        },
        failed: function () { return S.failed; },
        engine: function () { return S.used; },
        busy: function () { return !!S.pumping; },
        cancel: function () { if (S.ctl) try { S.ctl.abort(); } catch (e) { /* noop */ } },
        previewAt: function (tS) {
            if (!S.active || !S.sr) return null;
            var U = w.ProfanityVoiceUnderlay, i = Math.round(tS * S.sr);
            for (var k = 0; k < S.regions.length; k++) {
                var r = S.regions[k];
                if (tS < r.start - U.FADE || tS > r.end + U.FADE) continue;
                var sp = U.spansFor([r], S.sr, Math.ceil((S.duration + 2) * S.sr))[0];
                if (!sp || i < sp.i0 || i >= sp.i1) continue;
                for (var q = 0; q < S.cache.length; q++) {
                    var e = S.cache[q];
                    if (!covers(e, sp.i0, sp.i1)) continue;
                    var id = sp.i0 + ':' + sp.i1;
                    if (!S.previews[id]) {
                        var n = sp.i1 - sp.i0, buf = new AudioBuffer({ length: n, numberOfChannels: S.ch, sampleRate: S.sr });
                        for (var c = 0; c < S.ch; c++) {
                            var arr = new Float32Array(n);
                            for (var j = 0; j < n; j++) arr[j] = e.data[(sp.i0 - e.lo + j) * S.ch + c] / 32767;
                            buf.copyToChannel(arr, c);
                        }
                        S.previews[id] = buf;
                    }
                    return { id: id, t0: sp.i0 / S.sr, t1: sp.i1 / S.sr, buffer: S.previews[id] };
                }
                return null;
            }
            return null;
        },
        underlay: async function (o) {
            if (!S.active) throw new Error('VOICE_ONLY_OFF');
            if (S.failed) throw new Error(S.failed);
            var U = w.ProfanityVoiceUnderlay;
            S.regions = (o.regions || S.regions).map(function (r) { return { start: r.start, end: r.end }; });
            var tick = setInterval(function () {
                if (o.onProgress && S.planS > 0) o.onProgress(Math.min(1, S.doneS / S.planS), progressLine());
            }, 500);
            // скачивание — это согласие потратить время: разделяется всё недостающее
            S.go = true;
            goButton(false);
            try {
                while (missingWindows().length) await pump();
            } finally { clearInterval(tick); }
            var total = o.totalSamples, spans = U.spansFor(S.regions, S.sr, total), patches = [];
            for (var k = 0; k < spans.length; k++) {
                var sp = spans[k], e = null;
                for (var q = 0; q < S.cache.length; q++) if (covers(S.cache[q], sp.i0, sp.i1)) { e = S.cache[q]; break; }
                if (!e) throw new Error('VOICE_ONLY_GAP');
                var chans = [];
                for (var c = 0; c < S.ch; c++) {
                    var n = sp.i1 - sp.i0, arr = new Float32Array(n);
                    for (var j = 0; j < n; j++) arr[j] = e.data[(sp.i0 - e.lo + j) * S.ch + c] / 32767;
                    chans.push(arr);
                }
                patches.push({ i0: sp.i0, data: U.patchFor(sp, chans, sp.i0, S.sr, o.floor) });
            }
            report('underlay', { spans: spans.length, engine: S.used, floor: o.floor });
            return U.buildWav(S.sr, S.ch, total, patches);
        }
    };

    function register(tries) {
        var tool = w.__pcTool;
        if (tool && typeof tool.setVoiceLane === 'function') {
            tool.setVoiceLane(provider);
            var row = lane();
            if (row) row.hidden = false;
            var go = $('pc-voice-only-go');
            if (go) go.addEventListener('click', function () { provider.go(); });
            return;
        }
        if ((tries | 0) > 240) return;   // ядро так и не поднялось — флажок не показываем
        setTimeout(function () { register((tries | 0) + 1); }, 250);
    }

    w.ProfanityVocalLane = { windowsFor: windowsFor, provider: provider };
    if (typeof module !== 'undefined' && module.exports) module.exports = w.ProfanityVocalLane;
    if (d && lane()) {
        if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { register(0); });
        else register(0);
    }
})(typeof window !== 'undefined' ? window : globalThis);
